import Parse from "parse";

type OD3_Tenant = Parse.Object;

export interface Route_TypeAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  description: string;
  tenant: OD3_Tenant;
  transportation_device: string;
  value: number;
}

export class Route_Type extends Parse.Object<Route_TypeAttributes> {
  static className: string = "OD3_GTFS_Route_Type";

  constructor(data?: Partial<Route_TypeAttributes>) {
    super("OD3_GTFS_Route_Type", data as Route_TypeAttributes);
  }

  get description(): string {
    return super.get("description");
  }
  set description(value: string) {
    super.set("description", value);
  }
  get tenant(): OD3_Tenant {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant) {
    super.set("tenant", value);
  }
  get transportation_device(): string {
    return super.get("transportation_device");
  }
  set transportation_device(value: string) {
    super.set("transportation_device", value);
  }
  get value(): number {
    return super.get("value");
  }
  set value(value: number) {
    super.set("value", value);
  }
}

Parse.Object.registerSubclass("OD3_GTFS_Route_Type", Route_Type);
